import type { ReactNode } from "react";

/**
 * Footer simples: rola normalmente com a página, sem fixar no fundo da
 * viewport. O efeito arco-íris (RuixenGradientFooter) continua revelando
 * conforme a rolagem chega ao fim — ele próprio é fixo na viewport.
 */
export function FooterReveal({ children }: { children: ReactNode }) {
  return <div className="relative w-full">{children}</div>;
}
